import React, { useEffect } from "react";
import { Text } from "../../Atomics/Text";
import { Col, Flex } from "antd";
import useFetch from "../../../../server/useFetch";
import { isEmpty } from "../../../../utils/hooks/isEmpty";
import { REACT_APP_MIDDLEWARE_URL } from "../../../../utils/config/configs";
import { Widget } from "../../Atomics/Widget";
import Spinner from "../../Atomics/Spinner";
import { NoData } from "../../Atomics/NoData";

export const ComparativeAnalysis = ({ filtersSelected }) => {
  const analyticsComparativeRequests = filtersSelected?.ids?.map((id, index) =>
    useFetch(
      "/metrics",
      "analyticsMetric" + index,
      {
        id: id,
        periodicity: filtersSelected?.periodicity,
        startDate: filtersSelected?.startDate,
        endDate: filtersSelected?.endDate
      },
      true,
      null,
      REACT_APP_MIDDLEWARE_URL
    )
  );

  const analyticsComparative = analyticsComparativeRequests.map((request) => request.data);
  const analyticsComparativeIsFetching = analyticsComparativeRequests.some((request) => request.isFetching);
  const refetchAnalyticsComparative = () => analyticsComparativeRequests.forEach((request) => request.refetch());
  console.log('analyticsComparative ', analyticsComparative);

  useEffect(() => {
    if (filtersSelected) {
      refetchAnalyticsComparative();
    }
  }, [filtersSelected]);

  return (
    <>
      {analyticsComparativeIsFetching ? (
        <Flex justify="center" align='center' style={{ height: "100%" }}>
          <Spinner stroke="green" size="42px" />
        </Flex>
      ) : (
        analyticsComparative?.map((item, index) => {
          return (
            <Col span="24" key={index} style={{ marginBottom: "16px" }}>
              <div className="title">
                <Text
                  $fontColor="coolgray-12"
                  $fontSize="text_xl"
                  $weight="regular"
                  $marginRight="s03"
                  $marginBottom="s08"
                >
                  {filtersSelected?.names?.[index]}
                </Text>
              </div>
              {isEmpty(item) ? (
                <NoData />
              ) :
                Object.values(item).map((data, index) => {
                  return (
                    <Widget
                      key={index}
                      data={{
                        id: 13,
                        width: "auto",
                        background: "white",
                        icon: null,
                        charts: [
                          {
                            height: "447px",
                            chartType: "columnsChartApex",
                            isFetching: analyticsComparativeIsFetching,
                            data: data?.data && !isEmpty(data.data) ?
                              serializeAnalyticComparativeChartData(data) : null
                          }
                        ]
                      }}
                    />
                  )
                })
              }
            </Col>
          )
        })
      )}
    </>
  );
};

const serializeAnalyticComparativeChartData = (data, periodicity) => {
  const newUnit = data.unit;
  const series = [];

  Object.entries(data.data).map(([key, value]) => {
    const formattedDate = `${key.split('T')[0].split('-').slice(1).reverse().join('/')} ${key.split('T')[1].split(':').slice(0, 2).join(':')}`; // Converts "2025-07-01T00:00" to "07/01 00:00"
    series.push({ x: formattedDate, y: Number(value) });
  });

  return {
    series: [{
      name: "",
      data: series
    }],
    categories: [],
    tooltip: null,
    unit: newUnit,
    columnWidth: 20,
    xAxisLabel: null,
    yAxisLabel: newUnit,
    color: ['yellow'],
    // formatterType: "Daily",
    tickAmount: 24,
    filename: "Gráfico exportado",
    headerValue: "valores",
    headerCategory: "categorias",
    showTooltipTitle: true,
    showLegend: false,
  }
};